import React from "react";
import { motion } from "framer-motion";
import { springVariants, springViewport } from '../utils/framerVariants';

const RichTexts = ({ data }) => {
  const hasSpacing = data.RichMargins && data.RichMargins.startsWith("Less");
  const containerClasses = `richtext container mx-auto max-w-6xl lg:max-w-7xl 2xl:max-w-8xl px-4 md:px-24 xl:px-24 ${
    hasSpacing ? "mb-16 md:mb-20" : "mb-16 md:mb-24 lg:mb-32 xl:mb-48"
  }`;

  return (
    <article className={containerClasses}>
      {data.Text &&
        <motion.div
          variants={springVariants}
          initial="invisible"
          whileInView="visible"
          viewport={springViewport}
          dangerouslySetInnerHTML={{
            __html: data.Text,
          }}
        />
      }
    </article>
  );
};

export default RichTexts;
